<template>
    <div class="cmp_mobile-footer">
        <div class="footer_logo">
            <img :src="require('../assets/images/footer-logo.png')" alt="MediaGo">
            <p class="text-bold">全球AI整合营销平台</p>
        </div>
        <div class="footer-center">
            <div v-for="(v, k, i) in footerSeries" :key="i">
                <h3 class="subtitle">{{k}}</h3>
                <ul class="series_list">
                    <li v-for="item in v" :key="item.id" class="series_item" @click="handlePageChange(item)">{{item.title}}</li>
                </ul>
            </div>
        </div>
        <div class="footer-bottom">
            <h3 class="title">关注获取更多营销资源</h3>
            <img :src="require('../assets/images/qrCode1.png')" alt="MediaGo" class="qrCode">
            <p class="text">邮箱：baiduglobal_sales@baidu.com</p>
            <p class="text">电话：0755-21972529</p>
            <p class="text company-name">百度（香港）有限公司</p>
            <p class="text company-name">百度国际科技（深圳）有限公司</p>
            <p class="text">地址：Suite 3101，Everbright Centre，108 Gloucester road ，Wanchai ,HK</p>
            <p class="text">邮编：999077</p>
        </div>
    </div>
</template>

<script>
import {footerSeries} from '@/modules/mobile/constants/home';
export default {
    name: 'cmp_mobile-footer',
    data() {
        return {
            footerSeries: footerSeries
        };
    },
    components: {},
    watch: {},
    mounted() {},
    methods: {
        handlePageChange(item) {
            if (!item.path) return false;
            window.gtag && window.gtag('event', 'cmp_bottom_click', {
                'event_category': 'cmp_partner_mobile_click',
                'event_label': item.title
            });
            if (item.id === 306) {
                window.open(item.path + '#' + item.anchor);
                return;
            }
            if (item.key) {
                window.location.href = '/business/mobile/' + item.path + '?' + item.keyName + '=' + item.key;
                return false;
            }
            if (item.anchor) {
                window.location.href = '/business/mobile/' + item.path + '?anchor=' + item.anchor;
                return false;
            }
            if (item.path) {
                window.location.href = '/business/mobile/' + item.path;
            }
        }
    }
};
</script>

<style scoped lang="scss">
 .cmp_mobile-footer{
    background: #0B1531;
    padding: mvw(50) mvw(30);
    position: relative;
    z-index: 3;
    .footer_logo {
        width: mvw(173);
        // height: mvw(51);
        &>img {
            width: mvw(173);
            // height: mvw(50);
        }
        .text-bold {
            font-weight: bold;
            font-size: mvw(14);
            text-align: justify;
            color: #6B7799;
            &::after {
                display: inline-block;
                width: 100%;
                content: '';
                height: 0;
            }
        }
    }
    .footer-center {
        margin: mvw(40) auto mvw(55);
        text-align: left;
        .subtitle {
            font-family: PingFangSC-Semibold;
            font-weight: 700;
            font-size: mvw(14);
            color: #8F9FCC;
            letter-spacing: 0;
            line-height: mvw(14);
            margin-bottom: mvw(15);
        }
        .series_list {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            flex-wrap: wrap;
            margin-bottom: mvw(20);
            .series_item {
                font-family: PingFangSC-Regular;
                font-size: mvw(14);
                color: #6B7799;
                letter-spacing: 0;
                line-height: mvw(14);
                margin-right: mvw(30);
                margin-bottom: mvw(15);
                white-space: nowrap;
            }
        }
    }
    .footer-bottom {
        text-align: center;
        .title {
            font-family: PingFangSC-Semibold;
            font-weight: 700;
            font-size: mvw(14);
            color: #8F9FCC;
            letter-spacing: 0;
            line-height: mvw(14);
            margin-bottom: mvw(15);
        }
        .qrCode {
            width: mvw(145);
            height: mvw(145);
            margin-bottom: mvw(25);
        }
        .text {
            font-family: SFUIText-Regular;
            font-size: mvw(12);
            color: #6B7799;
            letter-spacing: 0;
            line-height: mvw(12);
            margin-bottom: mvw(15);
            font-style: none;
        }
        .company-name {
            font-size: mvw(14);
            font-weight: bold;
        }
    }
 }
</style>



// WEBPACK FOOTER //
// src/modules/mobile/components/footer.vue